// extracted by mini-css-extract-plugin
export var dataCell = "_h3-2";
export var dataRow = "_h3-0";
export var headerRow = "_h3-1";